import { Injectable } from '@angular/core';
import {AuthResponse, Logger, Register, User} from '../auth.model';
import {BehaviorSubject, catchError, map, Observable, Subject, throwError} from 'rxjs';
import {GeneralResponse, Region} from '../../parametre/parametre.model';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {FormGroup} from '@angular/forms';
import {ToasterService} from '../../../globalServices/toaster.service';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

    regionSubject = new BehaviorSubject<Region>(new Region);
    loggedUser: User;
    responseValue : boolean = true;
     cv_doc="cv";
    sendCode : boolean = false;
    isCodeSent= false;

    private readonly OTP_ATTEMPT_KEY = 'otp_attempt_count';
    private readonly OTP_LOCKED_UNTIL_KEY = 'otp_locked_until';
    private cooldownInterval: any;
    otpCooldownRemaining$ = new BehaviorSubject<number>(0);
    card_id_doc="card_id";
    diplome_doc="diplome";
    server: string = environment.globals.url;
    urlApi: string = environment.globals.urlApi;
    // urlApi = "http://localhost:8000/api";
    codeEmail: string;
    otpMethode: string = 'whatsapp';
    otpFallbackAvailable: boolean = false;

    permissions: string[] = [];

    // private loggedIn$ = new BehaviorSubject<boolean>(false);

  constructor(
      private http: HttpClient,
      private toastr: ToasterService,
      public router:Router,
  ) {
      this.urlApi = environment.globals.urlApi;


      // this.loggedUser= new User();
    // this.headers.append('content-type', 'application/json');
    // this.headers.append('accept', 'application/json');
    // this.headers.append('Access-Control-Allow-Origin', environment.globals.urlApi);
  }


    messageConsole(data): void {
        console.log(data);

    }

    isMobile(): boolean {
        return /Mobi|Android|iPhone|iPod/i.test(navigator.userAgent);
    }

    isTablet(): boolean {
        return /Tablet|iPad/i.test(navigator.userAgent);
    }
    register(user: any): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };

        return this.http.post<any>(this.urlApi + '/auth/email/register', user, httpOptions);
    }

    uploadFile(selectedFile: File, fileForm: FormGroup, url_type_file: string, spinner: NgxSpinnerService, onSuccess?: (fileId: number) => void) {
        const token = this.getToken();
        spinner.show().then(r => r);

        const formData = new FormData();
        formData.append('fichier', selectedFile);
        formData.append('user_id', this.loggedUser.id.toString());

        this.http.post(this.urlApi + url_type_file, formData, { headers: this.getHeadersData(token) })
            .subscribe(
                (data) => {
                    const responseGeneral = data as any;
                    if (responseGeneral.success) {
                        spinner.hide().then(r => r);
                        const uploadedFileId: number = responseGeneral.data?.id;
                        this.toastr.success("Fichier ajouté avec succès", "Opération réussie");
                        fileForm.reset();
                        this.loginUserByToken(this.getToken()).subscribe(
                            (data) => {
                                const res = data as GeneralResponse;
                                if (res.success) {
                                    this.loggedUser = res.data["user"];
                                    this.getUserDataFile(this.loggedUser);
                                    if (onSuccess) onSuccess(uploadedFileId);
                                }
                            },
                            (error) => { console.error('Authentication error:', error); }
                        );
                    } else {
                        spinner.hide().then(r => r);
                        this.toastr.error("Erreur d'ajout de fichier", "Opération échouée");
                    }
                },
                (error) => {
                    spinner.hide().then(r => r);
                    console.error('error:', error);
                    this.toastr.error("Erreur d'ajout de fichier", "Opération échouée");
                }
            );
    }

    // login(user: any): Observable<any> {
    //     const httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json'
    //         })
    //     };
    //
    //     return this.http.post<any>(this.urlApi + '/auth/login/email', user, httpOptions);
    // }

    login(user: any): Observable<AuthResponse> {

      // var loggedIn = false;
      var loggedIn$ = new Subject<boolean>();

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };

      return   this.http.post<any>(this.urlApi + '/auth/login/email', user, httpOptions)
            .pipe(
                map(
                    (response) => ({...response})
                )
            )


        // return loggedIn$
    }
    requestPasswordReset(data: any): Observable<AuthResponse> {

      // var loggedIn = false;
      var loggedIn$ = new Subject<boolean>();

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };

      return   this.http.post<any>(this.urlApi + '/auth/password/email', data, httpOptions)
            .pipe(
                map(
                    (response) => ({...response})
                )
            )


        // return loggedIn$
    }

    resendEmailVerification(data: any): Observable<AuthResponse> {

        // var loggedIn = false;
        var loggedIn$ = new Subject<boolean>();

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };

        return   this.http.post<any>(this.urlApi + '/email/verification-notification', data, httpOptions)
            .pipe(
                map(
                    (response) => ({...response})
                )
            )


        // return loggedIn$
    }

    getUserDataFile(user:User){
        // this.loggedUser = user;
        this.loggedUser.cv_docs=[];
        this.loggedUser.pid_docs=[];
        this.loggedUser.diplome_docs=[];
        //console.log("fichiers",this.loggedUser.fichiers);

        for (const doc of this.loggedUser.fichiers) {
            if (doc.module.toLowerCase()==this.cv_doc.toLowerCase()){
                this.loggedUser.cv_docs.push(doc);
            };
            if (doc.module.toLowerCase()==this.card_id_doc.toLowerCase()){
                this.loggedUser.pid_docs.push(doc);

            };
            if (doc.module.toLowerCase()==this.diplome_doc.toLowerCase()){
                this.loggedUser.diplome_docs.push(doc);

            };

        }
    }

    loginUserByToken(token: string): Observable<any> {
        // const httpOptions = {
        //     headers: new HttpHeaders({
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${token}`
        //     })
        // };
        // this.parametreService.initAllParams(this.getHeaders(token));

        return this.http.post<any>(this.urlApi + '/auth/login/token', {}, {headers: this.getHeaders(token)});
    }
    getUserById(token: string,id: number): Observable<any> {
        // const httpOptions = {
        //     headers: new HttpHeaders({
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${token}`
        //     })
        // };
        // this.parametreService.initAllParams(this.getHeaders(token));

        return this.http.post<any>(this.urlApi + '/auth/only/user', {
            user_id: id,
        }, {headers: this.getHeaders(token)});
    }

    getSituationMatrimoniale(code: string): string {
        const situationItems: { [key: string]: string } = {
            'C': 'Célibataire',
            'M': 'Marié(e)',
            'D': 'Divorcé(e)',
            'V': 'Veuf/Veuve',
        };

        return situationItems[code.toUpperCase()] || 'Inconnue';
    }

    signOut(): void {
        window.sessionStorage.clear();
    }

    public saveToken(token: string): void {
        window.sessionStorage.removeItem(TOKEN_KEY);
        window.sessionStorage.setItem(TOKEN_KEY, token);
    }

    public getToken(): string | null {
        return window.sessionStorage.getItem(TOKEN_KEY);
    }

    getHeadersData(token?: string) {
        var valueToken = '';
        if(this.getToken() !== null) {
            valueToken = this.getToken();
        }
    //  //console.log("Mon token",valueToken);

        return new HttpHeaders({
           // 'Content-Type': 'application/json',
            // 'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token ? token: this.getToken()}`
        });

      // return {
      //   'Content-Type': 'application/json',
      //   'accept': 'application/json',
      //   'Access-Control-Allow-Origin': this.server,
      //   'Authorization': 'Bearer ' + token ? token: valueToken
      //   };
    }
    getHeaders(token?: string) {

        if(this.getToken() !== null) {
            valueToken = this.getToken();
        } //console.log("Mon token",token);
        var valueToken = '';

      console.log("Mon token",token);
      console.log("Mon token this.getToken()",this.getToken());

        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.getToken()}`
        });

      // return {
      //   'Content-Type': 'application/json',
      //   'accept': 'application/json',
      //   'Access-Control-Allow-Origin': this.server,
      //   'Authorization': 'Bearer ' + token ? token: valueToken
      //   };
    }
    hasPermission(permission: string): boolean {
        // console.log("loggedUser.permissions:", this.loggedUser.permissions);

        return this.loggedUser.permissions.includes(permission);
    }
    isAuthenticated(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const token = this.getToken();
            //console.log("Token récupéré:", token);

            if (!token) {
                resolve(false); // No token, return false immediately
                return;
            } else {
                this.loginUserByToken(token).subscribe(
                    (data) => {
                        const responseGeneral = data as GeneralResponse;
                        //console.log("Réponse de l'API:", responseGeneral);
                        if (responseGeneral.success) {
                            //console.log("user data by token: ", responseGeneral.data["user"]);
                            this.loggedUser = responseGeneral.data["user"];

                            if (!this.loggedUser || this.loggedUser.email_verified_at === null) {
                                this.toastr.error("Profil non vérifié", "Opération échouée");
                                resolve(false); // Authentication failed
                                return;
                            }

                            this.getUserDataFile(this.loggedUser);
                            //console.log("custom user data par token: ", this.loggedUser);
                            resolve(true); // Authentication successful
                        } else {
                            resolve(false); // Authentication failed
                        }
                    },
                    (error) => {
                        console.error('Erreur d\'auth:', error);
                        this.toastr.error("Erreur de connexion", "Veuillez réessayer");
                        reject(error); // Handle error appropriately
                    }
                );
            }
        });
    }
    getCooldownRemaining(): number {
        const lockedUntil = parseInt(localStorage.getItem(this.OTP_LOCKED_UNTIL_KEY) || '0');
        const remaining = Math.ceil((lockedUntil - Date.now()) / 1000);
        return remaining > 0 ? remaining : 0;
    }

    formatCooldown(seconds: number): string {
        if (seconds <= 0) return '';
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        if (h > 0) return `${h}h ${m}min`;
        if (m > 0) return `${m}min ${s}s`;
        return `${s}s`;
    }

    private startCooldownTimer(): void {
        clearInterval(this.cooldownInterval);
        const tick = () => {
            const remaining = this.getCooldownRemaining();
            this.otpCooldownRemaining$.next(remaining);
            if (remaining <= 0) { clearInterval(this.cooldownInterval); }
        };
        tick();
        this.cooldownInterval = setInterval(tick, 1000);
    }

    initCooldownOnLoad(): void {
        if (!environment.production) {
            localStorage.removeItem(this.OTP_LOCKED_UNTIL_KEY);
            localStorage.removeItem(this.OTP_ATTEMPT_KEY);
            return;
        }
        if (this.getCooldownRemaining() > 0) { this.startCooldownTimer(); }
    }

    sendCodeTo(data: string, type: string, methode: string = 'whatsapp') {
        if (!environment.production) {
            // Mode développement : pas de cooldown
        } else {
            const remaining = this.getCooldownRemaining();
            if (remaining > 0) {
                this.toastr.warning(
                    `Veuillez patienter ${this.formatCooldown(remaining)} avant de renvoyer un code.`,
                    'Trop de tentatives'
                );
                return;
            }
        }

        this.isCodeSent = false;
        this.otpFallbackAvailable = false;
        this.sendCode = true;

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        if (type === 'phone') {
            this.http.post<any>(
                this.urlApi + '/auth/otp/send',
                { telephone: data.trim(), methode },
                httpOptions
            ).pipe(map(r => ({ ...r }))).subscribe({
                next: (res) => {
                    const r = res as GeneralResponse;
                    if (r.success === true) {
                        this.codeEmail = r.data?.code;
                        this.otpMethode = r.data?.methode || methode;
                        this.isCodeSent = true;
                        this.toastr.success('Code envoyé avec succès', 'Opération réussie');
                        this._applyOtpCooldown();
                    } else {
                        if (r.data?.fallback_disponible) {
                            this.otpFallbackAvailable = true;
                            this.toastr.warning('WhatsApp indisponible. Choisissez une autre méthode.', 'Envoi échoué');
                        } else {
                            this.toastr.error('Erreur SMS, réessayez.', 'Opération échouée');
                        }
                    }
                    this.sendCode = false;
                },
                error: () => {
                    this.toastr.error("Erreur d'envoi de code", 'Opération échouée');
                    this.sendCode = false;
                    this.isCodeSent = false;
                }
            });
        } else {
            this.http.post<any>(
                this.urlApi + '/auth/email/send-code-email',
                { email: data },
                httpOptions
            ).pipe(map(r => ({ ...r }))).subscribe({
                next: (res) => {
                    const r = res as GeneralResponse;
                    if (r.success === true) {
                        this.codeEmail = r.data;
                        this.isCodeSent = true;
                        this.toastr.success('Code envoyé avec succès', 'Opération réussie');
                        this._applyOtpCooldown();
                    }
                    this.sendCode = false;
                },
                error: () => {
                    this.toastr.error("Erreur d'envoi de code", 'Opération échouée');
                    this.sendCode = false;
                    this.isCodeSent = false;
                }
            });
        }
    }

    private _applyOtpCooldown(): void {
        if (!environment.production) { return; }
        const count = parseInt(localStorage.getItem(this.OTP_ATTEMPT_KEY) || '0');
        const cooldowns = environment.otpControl.cooldowns;
        const cooldownSec = cooldowns[Math.min(count, cooldowns.length - 1)];
        localStorage.setItem(this.OTP_LOCKED_UNTIL_KEY, (Date.now() + cooldownSec * 1000).toString());
        localStorage.setItem(this.OTP_ATTEMPT_KEY, (count + 1).toString());
        this.startCooldownTimer();
    }


    updateNotif(data: any,data_id,type_user:string,type): Observable<any> {
        // this.urlApi = environment.globals.urlApi;

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.getToken()}`

            })
        }
      let structNotif=this.urlApi + '/structure/notif'
      let candidatNotif=this.urlApi + '/candidat/notif'

        let  emaildataTosend={
            'id': data_id,
            'email': data,
        }
        let  phonedataTosend={
            'id': data_id,
            'telephone_fixe': data,
        }
        return this.http.post<any>(type_user==environment.globals.structure?structNotif:candidatNotif,type=="email"? emaildataTosend:phonedataTosend, httpOptions);
    }
    updateUserData(data: any): Observable<any> {
        // this.urlApi = environment.globals.urlApi;

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.getToken()}`

            })
        }
      let dataUrl=this.urlApi + '/auth/user/update'

        return this.http.post<any>(dataUrl,data, httpOptions);
    }



    getUserPermissions () {
        this.http.get<GeneralResponse>(
            // this.urlApi+"/users/permissions"+this.loggedUser.id,{headers: this.getHeaders()})
            this.urlApi+"/security/user/permissions",{headers: this.getHeaders()})
            // .pipe(
            //     map((response) => response.data.map(c => ({...c})))
            // )
            .subscribe({
                next: (value) => {
                    let responsePermission = new GeneralResponse();
                    responsePermission = value;
                    if (responsePermission.success === true){
                        // console.log("Données permissions utilisateur => ",responsePermission);
                        this.permissions = responsePermission.data;
                        // console.log("Contenue de auth.permission => ",this.permissions);
                    }else {
                        this.permissions = [];
                    }
                },
                error: (error) => {
                    this.permissions = [];
                }
            });
    }

    /**
     * Vérifie si l'utilisateur a un rôle spécifique.
     */
    hasRole(role: string): boolean {
        return this.loggedUser.profils.find( (value) => value.nom == role) != undefined;
    }

    /**
     * Vérifie si l'utilisateur a une permission spécifique.
     */
    // hasPermission(permission: string): boolean {
    //     // console.log("Contenue permissions => ",this.permissions);
    //     // console.log("Vérification permission :"+permission+" => ",this.permissions.find( (value) => value == permission));
    //     return this.permissions.find( (value) => value == permission) != undefined;
    // }
    // hasPermission(permission: string): boolean {
    //   console.log("Vérification permission :"+permission+" => ",this.permissions.find( (value) => value.nom == permission));
    //   return this.permissions.find( (value) => value.nom == permission) != undefined;
    // }


}
